module.exports = __webpack_public_path__ + "img/round-small.66dae56a.svg";